import { UseCases } from "src/pages/home/sections/UseCases";

export const UseCasesPage = () => (
  <section className="max-container w-full padding">
    <UseCases />
  </section>
);
